import Control from './uuid/Control.jsx'
import CMS from 'decap-cms-app';


window.CMS_MANUAL_INIT = true;


import languages from "../../content/settings/language.json"

import configDev from "../config.dev.js"
import configProd from "../config.js"

let config;

if (import.meta.env.PROD) {
    config = configProd;
} else if (import.meta.env.DEV) {
    config = configDev;
    console.log("Development mode");
}



// This is a hack to get the languages from the settings file.
config["i18n"] = {
    locales : languages.languages.map(language => language.code),
    structure: 'multiple_files',
    defaultLanguage : languages.languages[0].code
}



CMS.registerWidget('uuid', Control);


function transformData (entry, locale, isDefaultLocale) {

    let data = isDefaultLocale ? entry.get('data') : entry.get('i18n').get(locale).get('data');

    // Make sure it's supposed to have locale.
    console.log(data.get('locale'))
    if (data.get('locale')) {
        data = data.set('locale', locale);
    }


    const postSlug = data.get('postSlug');

    if (postSlug) {
        data = data.set('slug', `${locale}/${postSlug}`);
    }

    return data;
}


CMS.registerEventListener({
  name: 'preSave',
  handler: async ({ entry }) => {
    const defaultLanguage = config.i18n.defaultLanguage;

    // Transform the data for the default language.
    entry = entry.set('data', transformData(entry, defaultLanguage, true));

    const locales = entry.get('i18n');

    if (locales) {
        locales.forEach((obj, locale) => {
            entry = entry.setIn(['i18n', locale, 'data'], transformData(entry, locale, false));
        });
    }

    
    return entry;
  },
});

CMS.init(
    {config : config}
);